import { deepFreeze } from '../../utils/misc_utils';

export const EventRegisterReasonEnum = deepFreeze({
    NO_INTERNET: {
        value: 'NO_INTERNET',
        label: 'Brak internetu'
    },
    TERMINAL_FAILURE: {
        value: 'TERMINAL_FAILURE',
        label: 'Awaria terminala'
    },
    OTHER: {
        value: 'OTHER',
        label: 'Inny'
    },
    UNKNOWN: {
        value: 'UNKNOWN',
        label: 'Błąd'
    }
});
